<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('categories')">Categoria</inertia-link>
      <span class="text-white font-medium">/Crear</span>
    </h1>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-2/4" label="Nombre" required/>
                    <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-2/4" type="file" accept="image/*" label="Imagen" required/>

          <text-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-1/1" label="Descripción"/>
             </div>
              <br>  
                <div v-if="mensagge" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{mensagge}}
              </div>
              <br>  
        <div class="px-8 py-4 bg-transparent flex justify-end items-center">
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Agregar Categoria</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'
import axios from "axios";


export default {
  metaInfo: { title: 'Agregar Categoria' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    FileInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      mensagge: '',
      form: this.$inertia.form({
        name: '',
        description: '',
        photo: null,
      }),
    }
  },
  methods: {
    store() {
      this.mensagge='';
       var data = new FormData();
       data.append('photo', this.form.photo);
       data.append('description', this.form.description);
       data.append('name', this.form.name);
       data.append('_method', 'POST');
       axios.post('/categories',data).then(response => {
          this.mensagge=response.data;
      }); 
    },
  },
}
</script>
